import { yupResolver } from '@hookform/resolvers/yup';
import { format } from 'date-fns';
import { useTranslation } from 'next-i18next';
import React from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';

import OperationCelebration from '@/modules/Onboarding/components/OperationCelebration';
import { useCreatePeriodicOperation } from '@/modules/periodicTasks/apihooks';
import { useCreatePeriodicOperationUtils } from '@/modules/periodicTasks/components/Create/logic';
import { IPeriodicTasks } from '@/modules/periodicTasks/types';
import ConfirmationModal from '@/shared/components/molecules/ConfirmationModal';
import MultiStepForm from '@/shared/components/molecules/MultiStepForm';
import { useStore } from '@/shared/hooks/context/createGenericContext';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';
import { setExactHour } from '@/shared/lib/dates';

//  TODO: IMP - infinite scroll select fields

const CreatePeriodicOperation = () => {
  const { t } = useTranslation();

  const { openModal } = useModal();

  const [selectedAsset] = useStore((store) => store?.asset);

  const { getFormSteps, operationFormValidationSchema, getMutationObject } =
    useCreatePeriodicOperationUtils();

  const { mutate, isLoading } = useCreatePeriodicOperation();

  const methods = useForm<IPeriodicTasks.IOperationFormSchema>({
    resolver: yupResolver(operationFormValidationSchema),
    defaultValues: {
      status: 'pending',
      creationDate: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss'Z'"),
      causes: [],
      products: [{}],
      plots: [
        {
          startTime: setExactHour(6),
          endTime: setExactHour(7),
        },
      ],
    },
    mode: 'all',
  });

  const onSubmit: SubmitHandler<IPeriodicTasks.IOperationFormSchema> = (
    values
  ) => {
    mutate(
      { params: getMutationObject(values), entityId: selectedAsset?.id },
      {
        onSuccess: (data) => {
          data.isFirstCreation
            ? openModal(<OperationCelebration />, {
                onClose: (closeModal) => closeModal(3),
              })
            : openModal(
                <ConfirmationModal
                  header={t('create-operation-success')}
                  variant='success'
                  onDismissRemoveNumber={3}
                />,
                {
                  dismissable: false,
                }
              );
        },
      }
    );
  };

  return (
    <MultiStepForm<IPeriodicTasks.IOperationFormSchema>
      steps={getFormSteps(methods.watch('operationType.id'))}
      formMethods={methods}
      onSubmit={onSubmit}
      isMutating={isLoading}
      submitButtonLabel={t('create-operation')}
    />
  );
};

export { CreatePeriodicOperation };
